import Env from '../base/env';
import Channels from '../base/channels';
import Component from 'gia/Component';
import gsap from 'gsap'
import { enableScroll,disableScroll } from '../common/ScrollDisabler';
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
import {ScrollToPlugin} from '../vendor/gsap-bonus-umd/ScrollToPlugin';
import easesCustom from '../fx/CustomEases'
gsap.registerPlugin(ScrollTrigger,SplitText,ScrollToPlugin);
import { calculateMask } from '../fx/Common'
import WheelIndicator from 'wheel-indicator';


export default class Module extends Component
{
  mount() {
    //! Options
    this.options = JSON.parse(this.element.getAttribute('data-options'))
    this.options.lineThreshold = (typeof this.options.lineThreshold != 'undefined')?this.options.lineThreshold:.2;
    this.options.titleSelector = (typeof this.options.titleSelector != 'undefined')?this.options.titleSelector:'.fxTitle';
    this.options.titleTranslateY = (typeof this.options.titleTranslateY != 'undefined')?this.options.titleTranslateY:110;
    //! DOM
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.title = this.DOM.view.querySelector(this.options.titleSelector)
    this.DOM.subtitle = this.DOM.view.querySelector('.fxSubtitle')
    this.DOM.cache = this.DOM.view.querySelector('.fxCacheSEO')
    this.DOM.bg = this.DOM.view.querySelectorAll('.fxBg')
    this.DOM.fade = this.DOM.view.querySelector('.fxFade')
    this.DOM.mask = this.DOM.view.querySelector('.fxMask')
    this.DOM.logo = this.DOM.view.querySelector('.fxLogo')
    this.DOM.maskVisuals = this.DOM.view.querySelectorAll('.fxMaskVisual')
    //! VARS
    this.TYPE = this.DOM.view.getAttribute('data-type')
    this.FX = {}
    this.FX.titleLines = new SplitText(this.DOM.title, { type:'lines', linesClass:'tw-overflow-hidden',lineThreshold:this.options.lineThreshold })
    this.FX.titleChars = new SplitText(this.DOM.title, { type:'chars' })
    this.FX.settings = {
      title:{
        y:{
          from:this.options.titleTranslateY
        }
      }
    }
    this.VARS = {}
    this.VARS.DIRECTION = 1
    this.VARS.CAN_MOVE = false
    this.VARS.IS_ANCHORING = false
    //! Fns
    this.fadeScroll()
    if(Env.ios == false) {
      this.makeSticky()
    }

    this.funcLaunch = this._fx.bind(this)
    this.events()

    Channels.on('launcher::exit',this.funcLaunch)
    Channels.on('transition::end',this.funcLaunch)


  }

  events()
  {
    this.indicator = new WheelIndicator({
      elem: this.DOM.view,
      callback: (e)=>{
        this.VARS.DIRECTION = e.direction
        this.moveToLimit()
      }
    });
    this.indicator.getOption('preventMouse');
  }

  _fx()
  {
    this.reveal()
  }

  fadeScroll()
  {

    this.fade = ScrollTrigger.create({
      trigger:document.body,
      start:'top top',
      end:'+=100%',
      invalidateOnRefresh: true,
      onUpdate:(e)=>{
        gsap.set(this.DOM.fade,{ autoAlpha: e.progress})
      }
    })
  }

  makeSticky()
  {
    this.sticky = ScrollTrigger.create({
      trigger:this.DOM.view,
      start:'top top',
      pin:true,
      pinSpacing:false,
      end: () => ScrollTrigger.maxScroll(document.body),
      invalidateOnRefresh: true
    })
  }

  moveToLimit()
  {
    if(this.VARS.IS_ANCHORING == false) {
      if(this.VARS.DIRECTION == 'down') {
        const viewport = Env.framework.toolbox.getViewport()
        gsap.to(
          window,
          {
            scrollTo:viewport.height,
            duration:.8,
            ease:easesCustom.quart,
            onStart:()=>{
              this.VARS.IS_ANCHORING = true
            },
            onComplete:()=>{
              this.VARS.IS_ANCHORING = false
            }
          }
        )
      } else {
        gsap.to(
          window,
          {
            scrollTo:0,
            duration:.8,
            ease:easesCustom.quart,
            onStart:()=>{
              this.VARS.IS_ANCHORING = true
            },
            onComplete:()=>{
              this.VARS.IS_ANCHORING = false
            }
          }
        )
      }
    }
  }

  reveal()
  {
    this.tlReveal = gsap.timeline()

    this.tlReveal.add(()=>{
      gsap.set(this.FX.titleChars.chars, {y:this.FX.settings.title.y.from})
    })
    if(this.TYPE == 'landscape') {
      this.tlReveal.add([
        gsap.fromTo(
          this.DOM.cache,
          {
            autoAlpha:1
          },
          {
            autoAlpha:0,
            duration:1,
            ease:easesCustom.cubic
          }
        ),
        gsap.fromTo(
          this.DOM.bg,
          {
            scale:1.1
          },
          {
            scale:1,
            ease:'power3.out',
            duration:1.2,
            delay:.2
          }
        ),
      ])
    } else if(this.TYPE == 'portrait' || this.TYPE == 'dyptic' || this.TYPE == 'base') {
      this.tlReveal.add([
        gsap.fromTo(
          this.DOM.cache,
          {
            autoAlpha:1
          },
          {
            autoAlpha:0,
            duration:1,
            ease:easesCustom.cubic
          }
        ),
      ])
    }

    this.tlReveal.add([
      gsap.fromTo(
        this.FX.titleChars.chars,
        {
          y:this.FX.settings.title.y.from
        },
        {
          y:0,
          ease:easesCustom.quart,
          duration:1,
          stagger:.02,
          onComplete:()=>{
            if(this.FX.titleChars.chars[0].parentElement != null) {
              this.FX.titleChars.chars[0].parentElement.classList.remove('tw-overflow-hidden')
            }

          }
        }
      ),
    ],'-=1')
    if(this.DOM.subtitle != null) {
      this.tlReveal.add([
        gsap.fromTo(
          this.DOM.subtitle,
          {
            autoAlpha:0
          },
          {
            autoAlpha:1,
            ease:easesCustom.cubic,
            duration:1,
            delay:.3
          }
        ),
      ],'<')
    }
    if(this.DOM.logo != null) {
      this.tlReveal.add([
        gsap.fromTo(
          this.DOM.logo,
          {
            autoAlpha:0
          },
          {
            autoAlpha:1,
            ease:easesCustom.cubic,
            duration:1,
            delay:.3
          }
        ),
      ],'<')
    }
    if(this.TYPE == 'portrait' && this.DOM.mask != null) {
      this.tlReveal.add([
        gsap.fromTo(
          this.DOM.bg,
          {
            scale:1.2
          },
          {
            scale:1.01,
            ease:'quint.out',
            duration:1,
            delay:.25
          }
        ),
        gsap.fromTo(
          this.DOM.mask,
          {
            transformOrigin:'bottom center',
            scaleY:1
          },
          {
            scaleY:0,
            ease:easesCustom.quart,
            duration:1
          }
        )
      ],'<+.7')
    }
    if(this.TYPE == 'dyptic') {
      const clipFrom = calculateMask(this.DOM.mask,'from','height')
      const clipTo = calculateMask(this.DOM.mask,'to','height')
      this.tlReveal.add([
        gsap.fromTo(
          this.DOM.bg,
          {
            scale:1.2
          },
          {
            scale:1.01,
            ease:'quint.out',
            duration:1
          }
        ),
        gsap.fromTo(
          this.DOM.mask,
          {
            clip:clipFrom
          },
          {
            clip:clipTo,
            ease:'quint.out',
            duration:1,
            delay:.25
          }
        ),
        gsap.fromTo(
          this.DOM.maskVisuals,
          {
            scale:1.1
          },
          {
            scale:1,
            ease:'quint.out',
            duration:1.5,
            delay:.2
          }
        )
      ],'<.3')
    }
  }

  unmount()
  {
    Channels.removeListener('launcher::exit',this.funcLaunch)
    Channels.removeListener('transition::end',this.funcLaunch)
    this.fade.kill()
    this.sticky.kill()
    this.indicator.destroy()

  }
}
